import {isNil} from 'ramda';

import type {ChartReportDocument, ReportDocumentSection} from './ChartReportDocument';

export function getReportDocumentGroups(document: ChartReportDocument) {
  const includedIds = new Set<string>();
  const groups: Array<{sections: ReportDocumentSection[]; combineTables: boolean}> = [];

  for (const group of document.sectionGroups ?? []) {
    const sections = group.sectionIds.flatMap((id) => {
      const section = document.sections.find((candidate) => candidate.id === id);
      if (isNil(section) || includedIds.has(id)) {
        return [];
      }
      includedIds.add(id);
      return [section];
    });
    if (sections.length > 0) {
      groups.push({sections, combineTables: group.combineTables ?? false});
    }
  }

  for (const section of document.sections) {
    if (!includedIds.has(section.id)) {
      includedIds.add(section.id);
      groups.push({sections: [section], combineTables: false});
    }
  }
  return groups;
}
